
import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";

const StateWiseComparisonChart = ({ filteredData, selectedState, selectedDistrict }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (!filteredData || filteredData.length === 0) return;

    const myChart = echarts.init(chartRef.current);

    const uniqueStates = Array.from(
      new Set(
        filteredData.map((item) =>
          selectedState && !selectedDistrict
            ? item?.district_name
            : selectedDistrict
            ? item?.block_name
            : item?.state_name
        )
      )
    ).filter(Boolean); 


    const statuses = ["Total Count", "Lead Generated", "Proposal Form","Policy Issued","Policy Rejected"];

    const seriesData = uniqueStates.map((state) => ({
      name: state,
      type: "bar",
      barGap: "0%", 
      barWidth: 30, 
      emphasis: { focus: "series" },
      data: statuses.map((status) => {
        const stateData = filteredData.find((item) =>
          selectedState && !selectedDistrict
            ? item.district_name === state
            : selectedDistrict
            ? item.block_name === state
            : item.state_name === state
        );

        if (!stateData) return 0;

        return status === "Total Count"
          ? stateData.total_count || 0
          : status === "Lead Generated"
          ? stateData.lead_generated || 0
          // : status === "KYC Completed"
          // ? stateData.kyc_completed || 0
          : status === "Proposal Form"
          ? stateData.proposal_form_submitted || 0
          // : status === "Assigned Agency"
          // ? stateData.assigned_to_tagging_agency || 0
          : status === "Policy Issued"
          ? stateData.policy_issued || 0
          : status === "Policy Rejected"
          ? stateData.policy_rejected || 0
          : 0;
      }),
    }));

    // const option = {
    //   tooltip: { trigger: "axis", axisPointer: { type: "shadow" } },
    //   legend: { data: uniqueStates },
    //   xAxis: {
    //     type: "category",
    //     data: statuses,
    //     axisLabel: { rotate: 30 }, 
    //   },
    //   yAxis: { type: "value" },
    //   series: seriesData,
    // };

    // myChart.setOption(option);
   const option = {
  tooltip: { trigger: "axis", axisPointer: { type: "shadow" } },
  legend: { data: uniqueStates },
  xAxis: {
    type: "category",
    data: statuses,
    axisLabel: { rotate: 30 },
  },
  yAxis: {
    type: "log",
    min: 1,     
    axisLabel: {
      formatter: (value) => Math.round(value),
    },
  },
  series: seriesData.map((series) => ({
    ...series,
    data: series.data.map((val) => (val === 0 ? 0 : val)), 
  })),
};

myChart.setOption(option);

    return () => myChart.dispose();
  }, [filteredData, selectedState, selectedDistrict]); 

  return <div ref={chartRef} style={{ width: "100%", height: "320px" }} />;
};

export default StateWiseComparisonChart;
